export default {
  superAdmin: 'ROLE_SUPER_ADMIN',
  admin: 'ROLE_ORGANIZATION_ADMIN',
  educator: 'ROLE_EDUCATOR',
  advancedEducator: 'ROLE_ADVANCED_EDUCATOR',
  student: 'ROLE_STUDENT',
  guardian: 'ROLE_GUARDIAN',
}
